export enum AptPaymentInstrument {
    AddebitoCC = 'Addebito su Conto Corrente',
    Bollettino = 'Bollettino Postale',
    CartaCredito = 'Addebito su Carta di Credito',
    Altro = 'Altro (pagopa,portale Web,Bonifico semplice)',
}
